<div class="barcode-wrapper" >
    <svg #barcode></svg>
</div>
